<template>
  <div>
    <LoginUser v-if="showLogin" @user="storeLogin" />
    <div class="message">
      <font-awesome-icon icon="user-check" v-if="userLoggedIn" />{{message}}
      <font-awesome-icon @click="logoutUser" size="4x" icon="sign-out-alt" v-if="userLoggedIn" /></div>
  </div>
</template>

<script>
import rest from "../rest";
import LoginUser from "./LoginUser";

export default {
  name: "userStats",
  components: { LoginUser },
  data: () => {
    return {
      message: null,
      userLoggedIn: false,
      showLogin: false
    };
  },
  mounted() {
    this.loggedIn();
  },
  methods: {
    logoutUser() {
      rest.logout().then(() => {
        this.message = "";
        this.userLoggedIn = false;
        this.showLogin = true;
      });
    },
    loggedIn() {
      rest
        .loggedIn()
        .then(me => {
          const user = me.data.data;
          this.storeLogin(user);
        })
        .catch(() => {
          this.message = "";
          this.userLoggedIn = false;
          this.showLogin = true;
        });
    },
    storeLogin(user) {
      this.message =
        user.first_name + " " + user.last_name;
      this.userLoggedIn = true;
      this.showLogin = false;
    }
  }
};
</script>
<style scoped>
.message > *:last-child{
  margin-left: 0.6em;
}
</style>